<template>
  <el-dialog v-model="dialogVisible" title="导入证书结果">
    <div class="content">
      <div class="list-table">
        <el-descriptions title="AAA证书" :column="3">
          <el-descriptions-item width="33%" label="总数量">{{certResult.aaaResult.total}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="成功数量">{{certResult.aaaResult.successCount}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="失败数量">{{certResult.aaaResult.failCount}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="AA证书" :column="3">
          <el-descriptions-item width="33%" label="总数量">{{certResult.aaResult.total}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="成功数量">{{certResult.aaResult.successCount}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="失败数量">{{certResult.aaResult.failCount}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions title="A证书" :column="3">
          <el-descriptions-item width="33%" label="总数量">{{certResult.aResult.total}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="成功数量">{{certResult.aResult.successCount}}</el-descriptions-item>
          <el-descriptions-item width="33%" label="失败数量">{{certResult.aResult.failCount}}</el-descriptions-item>
        </el-descriptions>
      </div>
      <p>错误消息：</p>
      <textarea rows="30" style="height:200px;width:100%" v-model="certResult.error"> </textarea>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import {
  Category,
  CertImportResult,
  Content,
  NodeItem,
} from "@/script/apps/cms/entity/CmsEntity";
import { ElMessage } from "element-plus";
import { Options, Vue } from "vue-class-component";

@Options({})
export default class CertResult extends Vue {
  private dialogVisible = false;
  private certResult: CertImportResult | undefined;

  public show(certResult: CertImportResult) {
    this.certResult = certResult;
    this.dialogVisible = true;
  }
}
</script>
